export default function HighlightModal({ modalImage, modalText}) {


  return (
    <div className='highlight-modal'>
        <button className="highlight-modal-close-btn">X</button>
        <div className="highlight-modal-overlay"></div>
        <div className="highlight-modal-img">
        <img srcSet={modalImage} alt="#" />
        {modalText ? <div className="highlight-modal-text">
            <p>{modalText}</p>
        </div> : null}
        
        </div>
    </div>
  )
  
}
